import _implicitStylesheets from "./postHeader.css";
import _implicitScopedStylesheets from "./postHeader.scoped.css?scoped=true";
import _mfeShare from "mfe/share";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h1${"c0"}${2}>${"t1"}</h1>`;
const $fragment2 = parseFragment`<h2${"c0"}${2}>${"t1"}</h2>`;
const $fragment3 = parseFragment`<span class="info-date${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<span class="info-separator${0}"${2}> • </span>`;
const $fragment5 = parseFragment`<span class="info-read${0}"${2}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span class="info-separator${0}"${2}> • </span>`;
const $fragment7 = parseFragment`<span class="info-type${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "axwp-post-header": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-post-header__breadcrumbs": true
  },
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = {
  attrs: {
    "name": "breadcrumbs"
  },
  key: 3
};
const stc4 = [];
const stc5 = {
  classMap: {
    "axwp-post-header__title": true
  },
  key: 4
};
const stc6 = {
  attrs: {
    "name": "description"
  },
  key: 9
};
const stc7 = {
  classMap: {
    "axwp-post-header__post_meta": true
  },
  key: 10
};
const stc8 = {
  key: 11
};
const stc9 = {
  classMap: {
    "axwp-post-header__author": true
  },
  key: 12
};
const stc10 = {
  attrs: {
    "name": "byline"
  },
  key: 13
};
const stc11 = {
  classMap: {
    "axwp-post-header__info": true
  },
  key: 14
};
const stc12 = {
  classMap: {
    "axwp-post-header__share": true
  },
  key: 25
};
const stc13 = {
  "alignright": true
};
const stc14 = {
  classMap: {
    "axwp-post-header__badges": true
  },
  key: 27
};
const stc15 = {
  attrs: {
    "name": "badges"
  },
  key: 28
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {s: api_slot, h: api_element, ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_slot("breadcrumbs", stc3, stc4, $slotset)])]), $cmp.displayTitle ? api_element("div", stc5, [$cmp.displayTopTitle ? api_static_fragment($fragment1, 6, [api_static_part(0, {
    className: api_normalize_class_name($cmp.titleClass)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]) : null, !$cmp.displayTopTitle ? api_static_fragment($fragment2, 8, [api_static_part(0, {
    className: api_normalize_class_name($cmp.titleClass)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]) : null]) : null, api_slot("description", stc6, stc4, $slotset), api_element("div", stc7, [api_element("div", stc8, [api_element("div", stc9, [api_slot("byline", stc10, stc4, $slotset)]), $cmp.displayMeta ? api_element("div", stc11, [$cmp.displayDate ? api_static_fragment($fragment3, 16, [api_static_part(1, null, api_dynamic_text($cmp.date))]) : null, $cmp.displayDateSeparator ? api_static_fragment($fragment4, 18) : null, $cmp.displayReadtime ? api_static_fragment($fragment5, 20, [api_static_part(1, null, api_dynamic_text($cmp.readtime))]) : null, $cmp.displayReadtimeSeparator ? api_static_fragment($fragment6, 22) : null, $cmp.displayContentType ? api_static_fragment($fragment7, 24, [api_static_part(1, null, api_dynamic_text($cmp.contentType))]) : null]) : null]), $cmp.displayShare ? api_element("div", stc12, [api_custom_element("mfe-share", _mfeShare, {
    classMap: stc13,
    props: {
      "url": $cmp.postLink,
      "wrapperClass": "alignright",
      "title": $cmp.shareTitle,
      "tooltip": $cmp.copyTooltip
    },
    key: 26
  })]) : null]), api_element("div", stc14, [api_slot("badges", stc15, stc4, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["badges", "breadcrumbs", "byline", "description"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-fjbdu8qos8";
tmpl.legacyStylesheetToken = "undefined-_postHeader";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
